export function transformObjectKeys(object, fn, deep = true) {
  if (Array.isArray(object)) return deep ? object.map(value => transformObjectKeys(value, fn, deep)) : object;

  if (object && typeof object === 'object') {
    return Object
      .entries(object)
      .reduce((object, [ key, value ]) => {
        object[fn(key)] = deep && (typeof value === 'object' && value !== null)
          ? transformObjectKeys(value, fn, deep)
          : value;

        return object;
      }, {});
  }

  return object;
}
